import { toast } from "react-toastify";
import CommonService from "../services/common.service";
import { API_URLS } from "../constants/api-urls";
import { setLogisticsRfqSubmittedSessionFlag } from "../pages/website/logisticsRfqBrowseFlags";
import { completeP2pRfqLinkAfterModuleCreate, navigateToP2pTransactionSourcing } from "./p2pRfqLinkAfterCreate";

/**
 * P2P logistics RFQ: create RFQ only (no provider matching/selection), run approval gate if configured.
 */
export async function submitP2pLogisticsRfq({
  payload,
  rfqKind = "generic",
  p2pLaunchContext,
  navigate,
  searchParams,
}) {
  const res = await CommonService.post(API_URLS.LOGISTICS_PROVIDER.RFQ_GENERIC, {
    payload: {
      ...payload,
      companyId: null,
    },
    rfqKind,
  });

  if (!res?.success) {
    throw new Error(res?.message || "Could not create logistics RFQ.");
  }

  const data = res?.data || {};
  const approval = data.approval || {};
  const requiresApproval = approval.mode === "pending";
  const message = requiresApproval
    ? "RFQ created successfully and submitted for approval."
    : "RFQ created successfully.";

  setLogisticsRfqSubmittedSessionFlag();

  const rfqId = data.id;
  const linkedToP2p =
    p2pLaunchContext?.p2p_transaction_id && rfqId
      ? await completeP2pRfqLinkAfterModuleCreate({
          searchParams,
          sourceModule: "logistics",
          sourceRfqId: rfqId,
          sourceRfqCode: data.rfqReferenceNumber || null,
          sourceRfqTitle: payload?.companyName
            ? `Logistics RFQ — ${payload.companyName}`
            : "Logistics RFQ",
          sourceRfqStatus: requiresApproval ? "pending_approval" : "approved",
          sourceUrl: rfqId ? `/logistics-providers/rfq/view?id=${rfqId}` : null,
          navigate,
          p2pLaunchContext,
        })
      : false;

  toast.success(message);

  if (p2pLaunchContext?.p2p_transaction_id) {
    navigateToP2pTransactionSourcing(navigate, p2pLaunchContext.p2p_transaction_id);
  }

  return {
    id: rfqId,
    requiresApproval,
    approvalRequestId: approval.approval_request_id ?? null,
    linkedToP2p,
  };
}
